import { ALL_INSIDE_FIFA_TEAM_GROUPS } from 'inside-fifa/setup/auth';
import { Group, User } from 'types/auth';

// user roles
export const BO_ADMIN = 'ROL_MEDIAHUB-BO-Admin';

// user groups
export const CALENDAR_MEDIA_OFFICERS = 'FMC_Calendar_Media_Officers';

export const ALL_USER_GROUPS = [CALENDAR_MEDIA_OFFICERS, ...ALL_INSIDE_FIFA_TEAM_GROUPS];

export const isAdmin = (user: User) => {
    return 'roles' in user && Array.isArray(user.roles) && user.roles.includes(BO_ADMIN);
};

export const isUserInAllowedGroup = (
    userGroups: Array<Group> | Array<string>,
    allowedGroups: Array<string>,
): boolean => {
    if (!userGroups) return false;

    const lowerCaseAllUserGroups = allowedGroups.map((item) => item.toLowerCase());

    return userGroups.some((userGroup) =>
        lowerCaseAllUserGroups.includes(
            typeof userGroup === 'string' ? userGroup.toLowerCase() : userGroup.name.toLowerCase(),
        ),
    );
};

export const isUserAuthorized = (user: User | null | undefined, allowedGroups: string[] = ALL_USER_GROUPS) => {
    if (!user) {
        // User is null or undefined
        return false;
    }
    if (isAdmin(user)) {
        return true;
    }

    const userHasRequiredGroup =
        'groups' in user && Array.isArray(user.groups) && isUserInAllowedGroup(user.groups, allowedGroups);

    // Check if the user has the allowed role
    return userHasRequiredGroup;
};

export const shouldMenuItemVisible = (user: User, allowedGroups: Array<string> | undefined): boolean => {
    if (!user) {
        // User is null or undefined
        return false;
    }

    if (isAdmin(user)) {
        return true;
    }

    if (!allowedGroups) {
        return false;
    }

    return isUserInAllowedGroup(user.groups, allowedGroups);
};
